<template>
  <article class="user_view">
    <modal-import v-if="isImporting" @import="onFileChange" @cancel="isImporting=false"></modal-import>
    <left-menu/>
    <section class="user_view__header" style="padding-right:20px">
      <div @click="$router.push({ name: 'Clients' })" class="back_button">
        <img src="./../../assets/img/icons/back-button.svg">
        <span>atrás</span>
      </div>
      <div class="user_view__header--info"> 
        <div>
          <h2>{{client.name}}</h2>
          <h4>NIT. {{client.nit}}</h4>
          
            <!--div class="date_filter">
                <input type="date" class="date_filter__selector">
                <button :class="{'active':true}"  class="secondary_button" >FILTRAR</button>
              
            </div-->
          <button  class="secondary_button" style="margin-top:20px;margin-bottom:20px" :class="{'click':isUpdate, 'active': !isUpdate}" @click="toUpdate" >ACTUALIZAR</button>
        </div>
         
        <div class="trainers__form--photo_container" v-if="isAdmin"  style="width:max-content;height:fit-content;margin-top:70px">
          <label
            class="primary_button" 
            for="excel_input"
            style="width:fit-content;padding: 16px 20px;margin-bottom:1px;border-radius:3px;height:42px;"
            >CARGAR CRONOGRAMA</label>
          <input style="display:none"
            id="excel_input"
            type="file"
            @change="activeImport"
            name="logo"
          >


          
        </div>
        <!-- <form action="https://v2.convertapi.com/convert/xls/to/pdf?Secret=RgBiCSgqzCyAgmZ1&download=attachment" method="post" enctype="multipart/form-data">
            <input type="file" name="File" />
            <input type="hidden" name="Timeout" value="420" />
            <input type="hidden" name="PdfResolution" value="600" />
            <input type="submit" value="Convert file"/>
        </form> -->
      </div>
  
     
      <info-table  :columns="columns" :items.sync="client.devices" :actions="false"/>
    </section>
    
  </article>
</template>

<script>
import Table from './../shared/Table';
export default {
  data(){
    return{
      
      columns:[
         {
          name: 'Puesto de trabajo',
          sortable: false,
        },
        {
          name: 'Dispositivo',
          sortable: false,
        },
       
      ],
      mockedClient: 
        {
          
          name: 'Fusepong S.A.S',
          nit: '451236 20 069823 1',
          city:'Bogotá',
          
          devices:[{
            number:319838238,
            company: 'Fusepong S.A.S',
            location: 'Piso 1 - Entrada 5 - Edificio de Gobernación de Neiva',
          },
          {
            number:320654545,
            company: 'Fusepong S.A.S',
            location: 'Piso 2 - Entrada 3 - Edificio de Gobernación de Neiva',
          }]
        },
      isUpdate:false,
      client:{devices:[]},
      excelTitle:'',
      myNewCronogram:null,
      isImporting:false,
      actualEvent:null,
      fileDate:"",
    }
  },
  components:{
    'info-table':Table, 
  },
  methods:{
    toUpdate(){
      this.isUpdate=true;  
       setTimeout(() => { this.isUpdate=false; }, 200);  
      const customActions={
        get: {headers:{"Authorization": 'Bearer '+localStorage.getItem('crypto')},method: 'GET'}                   
      };
      var card=JSON.parse(localStorage.getItem("user")).id_card; 
      this.$resource('company_devices/'+ this.$route.params.id,{},customActions).get()
      .then(function(data){
        this.client=data.body;
        //console.log(data.body[0].user);
      });
       
    },



    excelUpload(){
      var vm=this;
      var fileUpload = document.getElementById("excel_input");
      //Validate whether File is valid Excel file.
      var regex = /^([a-zA-Z0-9\s_\\.\-:])+(.xls|.xlsx|.ods|.xlsm|.xsv|.txt)$/;
      if (regex.test(fileUpload.value.toLowerCase())) {
          var vm=this;

          if (typeof (FileReader) != "undefined") {
            
            // console.log("SALIDA");
            // console.log(fileUpload.files[0])   
                     
            // const customActions={
            //   create: {headers:{"Access-Control-Allow-Origin":"*" ,"content-type": "application/json"},method: 'POST'}                   
            // };
            // this.resource= this.$resource('https://v2.convertapi.com/convert/xls/to/pdf?Secret=RgBiCSgqzCyAgmZ1',{},customActions);
            // this.resource.create({
            //           "Parameters": [
            //               {
            //                   "Name": vm.client.name,
            //                   "FileValue": {
            //                       "Name": vm.client.name+".xls",
            //                       "Data": fileUpload.files[0]
            //                   }
            //               }
            //           ]
            //       })
            // .then(function(data){
            //   console.log("ANSWER");
            //   console.log(data);
            // }).catch(function(err){
            //   console.log("ERROR DE CONVERSIÓN");
            //   console.log(err)
            // });

            var reader = new FileReader();
            vm.excelTitle=fileUpload.files[0].name;
            //For Browsers other than IE.
            if (reader.readAsBinaryString) {
                reader.onload = function (e) {
                    vm.usersJson={};
                    vm.ProcessExcel(e.target.result);
                };
                reader.readAsBinaryString(fileUpload.files[0]);
            } else {
                //For IE Browser.
                reader.onload = function (e) {
                    var data = "";
                    var bytes = new Uint8Array(e.target.result);
                    for (var i = 0; i < bytes.byteLength; i++) {
                        data += String.fromCharCode(bytes[i]);
                    }
                    vm.ProcessExcel(data);
                };
                reader.readAsArrayBuffer(fileUpload.files[0]);
            }
          } else {
              alert("This browser does not support HTML5.");
          }
      } else {
          alert("Por favor subir un cronográma válido (Formato Excel).");
      }
    },
    onFileChange (dateValue) {
      this.fileDate=dateValue;
      var e=this.actualEvent;
      var files = e.target.files || e.dataTransfer.files
      if (!files.length) {
        return
      }
      var name_field = ""+e.target.name
      this.url = URL.createObjectURL(files[0]);
      this.createExcel(files[0], name_field)


    },
    createExcel (file, name_field) {
      var reader = new FileReader()
      var vm = this
      reader.readAsDataURL(file);
      reader.onload = function () {
        vm.myNewCronogram=reader.result;
      }
    },
    activeImport(e){
      this.actualEvent=e;
      this.isImporting=true;
    },
    ProcessExcel(data) {
      var vm=this;
      //Read the Excel File data.
        var XLSX = require('xlsx');
        var workbook = XLSX.read(data, {
            type: 'binary'
        });
      var firstSheet = workbook.SheetNames[0];
      console.log("ENHORABUEN")
      console.log(workbook.Sheets);
      
      
     
      // //Fetch the name of First Sheet.
      //   var firstSheet = workbook.SheetNames[0];

      //   //Read all rows from First Sheet into an JSON array.
      //   var excelRows = XLSX.utils.sheet_to_json(workbook.Sheets[firstSheet]);
      //   console.log("EXCEL UPLOADED");
      //   console.log(excelRows);
    },



  },
  created(){
    this.isAdmin= JSON.parse(localStorage.getItem('isAdmin'));
    const customActions={
        get: {headers:{"Authorization": 'Bearer '+localStorage.getItem('crypto')},method: 'GET'}                   
    };
    this.$resource('company_devices/'+ this.$route.params.id,{},customActions).get()
    .then(function(data){
      this.client=data.body;
      //console.log(data.body[0].user);
    });
  },
  watch:{
    myNewCronogram(myExcel){
      const customActions={
        sendFile: {headers:{"Authorization" : 'Bearer '+ localStorage.getItem('crypto')},method: 'POST'}                   
      };
      this.$resource('administrators/dashboard',{},customActions).sendFile({"excel": myExcel,"company":this.$route.params.id,"date":this.fileDate})
      .then(function(data){
        console.log(data);
        this.isImporting=false;
      })
    },
  }
}

</script>



// WEBPACK FOOTER //
// src/components/pages/Client.vue